export interface ListKeys {
  keysFor: (listId: string, count: number) => string[];
  remove: (listId: string, index: number) => void;
}

// React keys that stay with an item when items before it are removed
export default function createListKeys(): ListKeys {
  let next = 0;
  const lists = new Map<string, string[]>();
  return {
    keysFor(listId, count) {
      const keys = (lists.get(listId) ?? []).slice(0, count);
      while (keys.length < count) {
        keys.push(`key_${next}`);
        next += 1;
      }
      lists.set(listId, keys);
      return keys;
    },
    remove(listId, index) {
      const keys = lists.get(listId);
      if (keys) {
        keys.splice(index, 1);
      }
    },
  };
}
